import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { deviceFromPet, getPetsWIthDevices } from '../../../helpers/dataHelpers.ts'
import { useSnapshot } from 'valtio'
import { dataState } from '../../../store/dataState.ts'
import { IPet } from '../../../interfaces/types.ts'
import { FindPetButton } from './FindPetButton.tsx'
import { controlState } from '../../../store/controlState.ts'

interface Props {
    menuAction: (a: IPet) => void
}

export const FindPetMenu: React.FC<Props> = (props) => {
    const petsWithDevices: string[] = getPetsWIthDevices()
    const pets = dataState.pets.filter(p => petsWithDevices.includes(p._id))
    const isMobile = useSnapshot(controlState).isOnMobileDevice

    const instructions = 'This will request an immediate check-in from your pets Gibi Tracker'
    const instructionSize = !isMobile ? 'text-md font-semibold' : 'text-base'

    const label = (
        <div className="prose text-left px-1 pb-4 flex flex-col justify-start gap-0">
            <div className={'flex items-center justify-between w-full'}>
                <h2 className={'opacity-80 mt-0 mb-0'}>Find your pet</h2>
                {!isMobile ?
                    <div className={'cursor-pointer'} onClick={() => controlState.findOpen = false}>
                        <FontAwesomeIcon icon={faClose} fontSize={'small'}/>
                    </div> : null}
            </div>
            <div className={`${instructionSize}`}>
                <article className={`p-2 opacity-80`}>
                    {instructions}
                </article>
            </div>
        </div>
    )

    const width = !isMobile ? 'max-w-[65vw]' : 'w-[90vw]'
    return (
        <div data-theme={'gibi'}>
            {label}
            <div
                className={`flex flex-col justify-start item-center ${isMobile ? 'gap-3' : 'gap-3 text-lg'} bg-base-100 p-4 pb-8 rounded-md shadow-lg text-primary ${width} max-h-[75vh] overflow-y-auto`}>
                {pets?.map(p => {
                    const d = deviceFromPet(p)
                    const disabled = !!d?.status.deviceCommandInProgressStatus
                    return (
                        <div key={p._id} className={'w-full'}>
                            <FindPetButton pet={p} action={props.menuAction} disabled={disabled}/>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
